import {
  BookCopy,
  Search,
  Shield,
  Star
} from "lucide-react";
import { Link } from "react-router-dom";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useAuthProfile } from "@/hooks/use-auth-profile";
import { Logo } from "../icons";

export function AppSidebar() {
  const { profile } = useAuthProfile();
  const isAdmin = profile?.isAdmin === true;

  return (
    <aside className="fixed inset-y-0 left-0 z-10 hidden w-14 flex-col border-r bg-card sm:flex">
      <nav className="flex flex-col items-center gap-4 px-2 sm:py-5">
        <Link
          to="/home"
          className="group flex h-9 w-9 shrink-0 items-center justify-center gap-2 text-lg font-semibold text-primary-foreground transition-all duration-200 ease-in-out hover:bg-primary/90 hover:scale-105 active:scale-100 md:h-8 md:w-8 md:text-base"
        >
          <Logo className="h-9 w-9 transition-transform duration-200 group-hover:scale-110" />
          <span className="sr-only">ezRecipeBox</span>
        </Link>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to="/home"
              className="flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground transition-all duration-200 ease-in-out hover:bg-sidebar-accent hover:text-foreground active:scale-95 md:h-8 md:w-8"
            >
              <BookCopy className="h-5 w-5" />
              <span className="sr-only">Recipe Boxes</span>
            </Link>
          </TooltipTrigger>
          <TooltipContent side="right">Recipe Boxes</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to="/search"
              className="flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground transition-all duration-200 ease-in-out hover:bg-sidebar-accent hover:text-foreground active:scale-95 md:h-8 md:w-8"
            >
              <Search className="h-5 w-5" />
              <span className="sr-only">Search</span>
            </Link>
          </TooltipTrigger>
          <TooltipContent side="right">Search</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to="/favorites"
              className="flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground transition-all duration-200 ease-in-out hover:bg-sidebar-accent hover:text-foreground active:scale-95 md:h-8 md:w-8"
            >
              <Star className="h-5 w-5" />
              <span className="sr-only">Favorites</span>
            </Link>
          </TooltipTrigger>
          <TooltipContent side="right">Favorites</TooltipContent>
        </Tooltip>
        {isAdmin && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Link
                to="/admin"
                className="flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground transition-all duration-200 ease-in-out hover:bg-sidebar-accent hover:text-foreground active:scale-95 md:h-8 md:w-8"
              >
                <Shield className="h-5 w-5" />
                <span className="sr-only">Admin</span>
              </Link>
            </TooltipTrigger>
            <TooltipContent side="right">Admin</TooltipContent>
          </Tooltip>
        )}
      </nav>
    </aside>
  )
}
